module.exports = __webpack_public_path__ + "static/img/banner.55cb195.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/banner.png
// module id = lBvy
// module chunks = 1